const generateSessionID = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
};

const sessionStart = () => {
    let sessionID = sessionStorage.getItem("SessionID");
    
    if (!sessionID) {
        sessionID = generateSessionID();
        sessionStorage.setItem("SessionID", sessionID);
        localStorage.setItem("SessionID", sessionID);
        localStorage.setItem("IsSession", true);
    }
    
    return sessionID;
};


export { sessionStart };

/**
 * Filters any array of items by matching their `assistantName` against `assistantList`.
 *
 * @param {Array<{ Name: string }>} assistantList 
 * @param {Array<{ assistantName: string }>} data 
 * @returns {Array}
 */
export function filterAssistantData(assistantList, data) {
  const validNames = new Set(assistantList.map(a => a.Name));
  return data.filter(item => validNames.has(item.assistantName));
}

